import { formatDate, ViewportScroller, DatePipe } from '@angular/common';
import { Component, inject, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Subscription } from 'rxjs';
import { AdjustmentService } from 'src/app/core/services/data/adjustment.services';
import { ApnUtilitiesService } from 'src/app/core/services/data/apn-utilities.service';
import { AuthService } from 'src/app/core/services/auth-security/auth.service';
import { InvoiceService } from 'src/app/core/services/data/invoice.service';
import { MessageService } from 'src/app/core/services/broadcast/message-service';
import { QueryMessageService } from 'src/app/core/services/broadcast/MessageDispatchingService';
import { QuicksearchService } from 'src/app/core/services/data/quicksearch.service';
import { dbErrorEntry } from 'src/app/shared/entities/dbErrorEntry';
import { InvoicePaymentWithExpectedDepositDate } from 'src/app/shared/entities/InvoicePaymentWithExpectedDepositDate';
import { PaidInvoicePayments } from 'src/app/shared/entities/PaidInvoicePayments';
import { PaymentRefundApprovalQuery } from 'src/app/shared/entities/PaymentRefundApprovalQuery';
import { PaymentTypes } from 'src/app/shared/entities/PaymentTypes';
import { paymentValidation } from 'src/app/shared/entities/paymentValidation';
import { QuickSearchCriteria } from 'src/app/shared/entities/QuickSearchCriteria';
import { QuickSearchResults } from 'src/app/shared/entities/QuickSearchResults';
import { ConfirmEnableScreenNegativePaymentComponent } from '../../dialog/confirm-enable-screen-negative-payment.component';
import { ConfirmNegativePaymentComponent } from '../../dialog/confirm-negative-payment.component';
import { InvalidRefundNoticeComponent } from '../../dialog/invalid-refund-notice.component';
import { QuickstartStateService } from 'src/app/core/services/state/quickstart-state.service';
import {
  IApnSpaceRefund,
  IConfirmPaymentTransferData,
  IInvoiceListWithBalance,
  IPaymentDeclineTransaction,
  ISettingsState,
  IRestrictedCharsError,
} from 'src/app/shared/interfaces';
import { DataService } from 'src/app/core/services/data/data.service';
import { Form, FormControl, FormGroup, RequiredValidator, Validators } from '@angular/forms';
import { invoice, vial } from '@igniteui/material-icons-extended';
import { ConfirmRefundComponent } from '../../dialog/confirm-refund.component';
import { DataDomainListService } from 'src/app/core/services/data/data-domain-list.service';
import { AppGeneralStateService } from 'src/app/app-general-state.service';
import { ConfirmTransferPaymentComponent } from 'src/app/core/dialog/dialog-confirm-transfer-payment/confirm-transfer-payment.component';
import { MessageDialogService } from 'src/app/core/services/helper/message-dialog.service';
import { DialogInvalidReferenceNumberComponent } from 'src/app/core/dialog/dialog-invalid-reference-number/dialog-invalid-reference-number.component';
import { DialogProcessingModalComponent } from 'src/app/core/dialog/dialog-processing-modal/dialog-processing-modal.component';
import { DialogSuccessModalComponent } from 'src/app/core/dialog/dialog-success-modal/dialog-success-modal.component';

@Component({
  selector: 'app-payment',
  templateUrl: './payment.component.html',
  styleUrls: ['./payment.component.scss'],
})
export class PaymentComponent implements OnInit, OnChanges, OnDestroy {
  @Input() invoiceNumber: string;

  paymentReversalForm: FormGroup;
  paymentReversalWithTransferForm: FormGroup;
  spaceRefundForm: FormGroup;
  spaceDeclineRefundForm: FormGroup;
  paymentTypes: PaymentTypes[] = [];
  invoicePayments: PaidInvoicePayments[] = [];
  invoicePeriod: string;
  customerName: string;
  invoiceAmount: number;
  invoiceBalance: number;
  quickSearchCriteria: QuickSearchCriteria;
  invoiceDetailData: QuickSearchResults;
  errorMessage: string = '';
  paymentsBeingAdded: boolean = false;
  showPaymentAdjustment: boolean = false;
  activePaymentAdjustmentId: string = '';
  subInvoiceDetail!: Subscription;
  invoiceBalanceList: IInvoiceListWithBalance[] = {} as IInvoiceListWithBalance[];

  paymentFormDepositDate: string;
  paymentValidationMessages: paymentValidation = new paymentValidation();
  isInvalid: boolean = true;
  paymentDataIsInvalid: boolean = true;
  referenceNumberPlaceholderForm: string = '';
  defaultPaymentType: string = '';
  pendingDirectDepositPayment: InvoicePaymentWithExpectedDepositDate = new InvoicePaymentWithExpectedDepositDate();
  isGB: Boolean;
  settingsStateValues: ISettingsState;
  showRefundWorkflowForm: boolean = false;
  showDeclineRefundWorkflowForm: boolean = false;
  selectedInvoicePaymentId: string = '';
  isPaymentPendingRefund: boolean = false;
  negativePaymentExceptionList: string[] = [];
  refNumberErrorCount: number = 0;
  refundInProcess: boolean = false;
  paymentReversalIsAdmin: boolean = false;
  workingBannerMessage: string = 'Working, Stand by...';
  successBannerMessage: string = 'Success Message Here';
  errorBannerMessage: string = 'Error Message Here';
  showWorkingBanner: boolean = false;
  showSuccessBanner: boolean = false;
  showErrorBanner: boolean = false;
  displayAdjustTab: boolean = true;

  //20240711 :: Ken Moss :: Moved services from constructor injection to inject statement
  //Services
  invoiceService = inject(InvoiceService);
  authService = inject(AuthService);
  adjustmentService = inject(AdjustmentService);
  viewportScroller = inject(ViewportScroller);
  messageService = inject(MessageService);
  quicksearchService = inject(QuicksearchService);
  apnUtilityService = inject(ApnUtilitiesService);
  messageDialogService = inject(MessageDialogService);
  _datePipe = inject(DatePipe);
  _snackBar = inject(MatSnackBar);
  dialog = inject(MatDialog);

  //Changed variable name from messageService to msgService.  Corrected Backlog Issue: https://aceparking.backlog.com/board/L2?selectedIssueKey=L2-270
  //quickstartStateService = inject(QuickstartStateService);
  msgService = inject(QueryMessageService);
  dataService = inject(DataService);
  _dataDomainService = inject(DataDomainListService);
  _appGeneralStateService = inject(AppGeneralStateService); //Added 20240711 :: Ken Moss
  _dialogService = inject(MessageDialogService);
  _matDialog = inject(MatDialog);
  _messageDialogService = inject(MessageDialogService);

  constructor() {
    this.GetPaymentExceptionist();

    this.paymentReversalIsAdmin = this._appGeneralStateService.isUserAdmin;
  }

  ngOnInit(): void {
    this.refNumberErrorCount = 0;
    this.InitPaymentReversalForm();
    this.InitPaymentReversalTransferForm();
    this.InitPaymentSpaceRefundForm();
    this.InitPaymentSpaceDeclineRefundForm();
    this.getAdminSettingsValues();
    this.initDataforInvoicePayment(this.invoiceNumber);

    this.paymentTypes = this.adjustmentService.getCurrentLotPaymentTypes();
    this.onScrollToTop();
  }

  onScrollToTop(): void {
    this.viewportScroller.scrollToPosition([0, 0]);
  }

  onSetAdjustTabPermissions(filterDescription: string) {
    filterDescription = filterDescription.toUpperCase();
    if (false == this._appGeneralStateService.isUserAdmin) {
      this.displayAdjustTab = ![
        'CARD SPACE PAYMENT',
        'CREDIT SPACE PAYMENT',
        'DEBIT SPACE PAYMENT',
        'APN SPACE PAYMENT',
      ].includes(filterDescription);
    } else {
      this.displayAdjustTab = true;
    }
  }

  getAdminSettingsValues() {
    this.dataService.getAdminAllSettingsStateValues().subscribe(
      (res) => {
        this.settingsStateValues = res;
      },
      (err: any) => {},
      () => {
        this._appGeneralStateService.isPaymentRefundOverrideActive = this.settingsStateValues.paymentRefundOverride;
      },
    );
  }

  onSubmitSpaceRefund(): void {
    let isSpaceRefund: boolean = false;
    let currentInvoicePayment: PaidInvoicePayments;
    let apnSpaceRefund: IApnSpaceRefund = {} as IApnSpaceRefund;
    let apnSpaceRefundList: IApnSpaceRefund[] = [];
    let amountAsString: string;

    currentInvoicePayment = this.invoicePayments.find((x) => x.invoicePaymentID == this.selectedInvoicePaymentId);

    amountAsString = this.spaceRefundForm.get('amount').value.toLocaleString().replaceAll(',', '');

    apnSpaceRefund.invoiceNumber = currentInvoicePayment.invoiceNumber;
    apnSpaceRefund.lotNumber = currentInvoicePayment.lotNumber;
    apnSpaceRefund.paymentAmount = +amountAsString.replace(',', '');
    apnSpaceRefund.referenceNumber = currentInvoicePayment.referenceNumber;
    apnSpaceRefund.transactionId = currentInvoicePayment.invoicePaymentID;
    apnSpaceRefund.requestId = currentInvoicePayment.requestId;
    apnSpaceRefund.comment = this.spaceRefundForm.get('comment').value;
    apnSpaceRefund.userName = this._appGeneralStateService.userName; //20240711:: Ken Moss Added per backlog issue: https://aceparking.backlog.com/board/L2?selectedIssueKey=L2-270

    apnSpaceRefundList.push(apnSpaceRefund);

    const dialogRefund = this.dialog.open(ConfirmRefundComponent, {
      data: { amount: amountAsString, name: this.customerName },
      width: '900px',
      height: '270px',
      position: { top: '75px' },
    });

    dialogRefund.afterClosed().subscribe((result) => {
      if (result == true) {
        this.showRefundWorkflowForm = false;
        this.showWaitBanner('Stand by.  Processing Refund...');
        this.PostApnSpaceRefund(apnSpaceRefundList);
      }
    });
  }

  PostApnSpaceRefund(apnSpaceRefund: IApnSpaceRefund[]): boolean {
    let status: boolean = true;

    this.dataService.postApnSpaceRefund(apnSpaceRefund).subscribe(
      (result) => {},
      (err: any) => {
        const err412Message: string = 'Refund cannot be processed because the customer no longer has a payment method on file. Please submit a refund request via Deep Blue.';
        const err428Message: string = 'Refund cannot be processed because the account has since been deleted. Please submit a refund request via Deep Blue.'
        const errGenericMessage: string = 'An unknown error occurred and this refund failed to process successfully.'
        let errorMessage: string = errGenericMessage;

        if (err?.status === 412) errorMessage = err412Message;
        else if (err?.status === 428) errorMessage = err428Message;

        this.showWorkingBanner = false;
        this._snackBar.open(errorMessage, '', {
          duration: 5000,
        });
        status = false;
      },
      () => {
        status = true;
        this.hideWaitShowSuccessBanner('This payment refund has been successfully processed.');
        this.getPaymentsForInvoiceNumber(this.invoiceNumber);
        this.getInvoiceDetailBalancesForInvoiceNumber(this.invoiceNumber);
      },
    );

    return status;
  }

  OnEvalShowDeclineRefundLink(invoicePaymentId): boolean {
    let showRefundLink: boolean = false;

    let currentInvoicePayment: PaidInvoicePayments;

    currentInvoicePayment = this.invoicePayments.find((x) => x.invoicePaymentID == invoicePaymentId);

    if (currentInvoicePayment.paymentStatus == 2) {
      showRefundLink = true;
    }

    return showRefundLink;
  }

  // Evaluate if the refund link should be shown for a given payment
  // 20250922 :: Ken Moss :: Updated parm list with amount.  Refund can only be displayed if amount > 0
  OnEvalShowRefundLink(invoicePaymentId: string, amount: number): boolean {
    let isSpaceRefund: boolean = false;
    let currentInvoicePayment: PaidInvoicePayments;

    currentInvoicePayment = this.invoicePayments.find((x) => x.invoicePaymentID == invoicePaymentId);

    if (
      (currentInvoicePayment.filterDescription.toUpperCase() == 'ACH SPACE PAYMENT' && amount > 0) ||
      (currentInvoicePayment.filterDescription.toUpperCase() == 'CREDIT SPACE PAYMENT' && amount > 0) ||
      (currentInvoicePayment.filterDescription.toUpperCase() == 'CARD SPACE PAYMENT' && amount > 0) ||
      (currentInvoicePayment.filterDescription.toUpperCase() == 'DEBIT SPACE PAYMENT' && amount > 0)
    ) {
      isSpaceRefund = true;
    } else return false;
    //paymentCode must be 'APNS' and > 0

    //Get balance of invoices for same referenceNumber
    //todo rename for paymentBalances.
    let invoiceBalance: number = this.GetBalancesForInvoicesWithSameParentPaymentId(
      currentInvoicePayment.parentPaymentId,
    );

    if (invoiceBalance <= 0)
      //Must be > 0
      return false;

    if (currentInvoicePayment.paymentTransactionType == 2) return false;

    if (currentInvoicePayment.paymentTransactionType == 4) return false;

    if (currentInvoicePayment.paymentTransactionType == 5) return false;

    if (currentInvoicePayment.paymentStatus == 3) return false;

    // if(currentInvoicePayment.paymentTransactionType == 3)
    //   return false;

    if (currentInvoicePayment.paymentDaysOld >= 30) return false;

    if (currentInvoicePayment.requestId == null) return false;

    return isSpaceRefund;
  }

  OnCloseRefundWorkflowForm(): void {
    this.showPaymentAdjustment = false;
    this.showRefundWorkflowForm = false;
  }

  OnShowDeclineRefundWorkflow(invoicePaymentId: string): void {
    this.OnCloseAllOtherPaymentForms();

    this.showDeclineRefundWorkflowForm = true;
    let currentInvoicePayment: PaidInvoicePayments;
    let maxCommentLength: number;

    this.selectedInvoicePaymentId = invoicePaymentId;

    currentInvoicePayment = this.invoicePayments.find((x) => x.invoicePaymentID == invoicePaymentId);

    this.isPaymentPendingRefund = currentInvoicePayment.paymentStatus === 2;

    maxCommentLength = 1024 - currentInvoicePayment.comments.length;

    this.spaceDeclineRefundForm.patchValue({
      comment: '',
    });

    this.spaceDeclineRefundForm.clearValidators();

    this.spaceRefundForm.get('comment').addValidators([Validators.required, Validators.maxLength(maxCommentLength)]);

    this.spaceDeclineRefundForm.updateValueAndValidity();
  }

  OnShowRefundWorkflow(invoicePaymentId: string): void {
    this.getAdminSettingsValues();
    this.OnCloseAllOtherPaymentForms();

    this.showRefundWorkflowForm = true;
    let currentInvoicePayment: PaidInvoicePayments;
    let maxCommentLength: number;

    this.selectedInvoicePaymentId = invoicePaymentId;

    currentInvoicePayment = this.invoicePayments.find((x) => x.invoicePaymentID == invoicePaymentId);

    this.isPaymentPendingRefund = currentInvoicePayment.paymentStatus === 2;

    maxCommentLength = 1024 - currentInvoicePayment.comments.length;

    let invoiceBalance: number = this.GetBalancesForInvoicesWithSameParentPaymentId(
      currentInvoicePayment.parentPaymentId,
    );

    this.spaceRefundForm.patchValue({
      amount: invoiceBalance,
      comment: '',
    });

    this.spaceRefundForm.clearValidators();

    this.spaceRefundForm.get('amount').addValidators([Validators.required, Validators.max(invoiceBalance)]);
    this.spaceRefundForm.get('comment').addValidators([Validators.required, Validators.maxLength(maxCommentLength)]);

    this.spaceRefundForm.updateValueAndValidity();
  }

  /*
    START GENERAL FUNCTIONS FOR PAYMENT REVERSALS
  */

  GetBalancesForInvoicesWithSameParentPaymentId(parentPaymentId: string): number {
    let ii: number;
    let balance: number = 0;

    for (ii = 0; ii < this.invoicePayments.length; ii++) {
      if (this.invoicePayments[ii].parentPaymentId == parentPaymentId) {
        balance = balance + +this.invoicePayments[ii].amount;
      }
    }

    return balance;
  }

  GetBalancesForInvoicesWithSameParentPaymentIdForDisplayingAdjustLink(parentPaymentId: string): number {
    let ii: number;
    let balance: number = 0;

    for (ii = 0; ii < this.invoicePayments.length; ii++) {
      if (this.invoicePayments[ii].parentPaymentId == parentPaymentId) {
        balance = balance + +this.invoicePayments[ii].amount;
      }
    }

    return balance;
  }

  GetUniqueId(parts: number): string {
    const stringArr = [];
    for (let i = 0; i < parts; i++) {
      // tslint:disable-next-line:no-bitwise
      const S4 = (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
      stringArr.push(S4);
    }
    return stringArr.join('-');
  }

  /* * * * * * * * * * * * * * *
    END GENERAL FUNCTIONS FOR PAYMENT REVERSALS
  * * * * * * * * * * * * * * */

  OnShowAdjustPayment(invoicePaymentId: string): void {
    const currentInvoicePayment = this.invoicePayments.find((x) => x.invoicePaymentID == invoicePaymentId);
    console.log('currentInvoicePayment', currentInvoicePayment);
    this.OnCloseAllOtherPaymentForms();
    this.onSetAdjustTabPermissions(currentInvoicePayment?.filterDescription);

    this.showPaymentAdjustment = true;
    this.activePaymentAdjustmentId = invoicePaymentId;
    this.SetPaymentReversalValues();
  }

  InitPaymentSpaceRefundForm(): void {
    this.spaceRefundForm = new FormGroup({
      amount: new FormControl('', [Validators.min(0.01)]),
      comment: new FormControl('', [Validators.required]),
    });
  }

  InitPaymentSpaceDeclineRefundForm(): void {
    this.spaceDeclineRefundForm = new FormGroup({
      comment: new FormControl('', [Validators.required]),
    });
  }

  /*
    START PAYMENT TRANSFER - NO TRANSFER
  */

  InitPaymentReversalForm(): void {
    this.paymentReversalForm = new FormGroup({
      amount: new FormControl('', [Validators.min(0.01)]),
      comment: new FormControl('', [Validators.required]),
      referenceNumber: new FormControl('', [Validators.required]),
      depositDate: new FormControl('', [Validators.required]),
      depositDateAsString: new FormControl('', [Validators.required]),
    });
  }

  OnResetPaymentReversalForm(): void {
    this.SetPaymentReversalValues();
  }

  OnResetSpaceRefundForm(): void {
    let currentInvoicePayment: PaidInvoicePayments;
    let maxCommentLength: number;

    currentInvoicePayment = this.invoicePayments.find((x) => x.invoicePaymentID == this.selectedInvoicePaymentId);

    this.isPaymentPendingRefund = currentInvoicePayment.paymentStatus === 2;

    maxCommentLength = 1024 - currentInvoicePayment.comments.length;

    let invoiceBalance: number = this.GetBalancesForInvoicesWithSameParentPaymentId(
      currentInvoicePayment.parentPaymentId,
    );

    this.spaceRefundForm.patchValue({
      amount: invoiceBalance,
      comment: '',
    });

    this.spaceRefundForm.clearValidators();

    this.spaceRefundForm.get('amount').addValidators([Validators.required, Validators.max(invoiceBalance)]);
    this.spaceRefundForm.get('comment').addValidators([Validators.required, Validators.maxLength(maxCommentLength)]);

    this.spaceRefundForm.updateValueAndValidity();
  }

  OnResetDeclineRefundForm(): void {
    let currentInvoicePayment: PaidInvoicePayments;
    let maxCommentLength: number;

    currentInvoicePayment = this.invoicePayments.find((x) => x.invoicePaymentID == this.selectedInvoicePaymentId);

    this.isPaymentPendingRefund = currentInvoicePayment.paymentStatus === 2;

    maxCommentLength = 1024 - currentInvoicePayment.comments.length;

    this.spaceDeclineRefundForm.patchValue({
      comment: '',
    });

    this.spaceDeclineRefundForm.clearValidators();

    this.spaceDeclineRefundForm
      .get('comment')
      .addValidators([Validators.required, Validators.maxLength(maxCommentLength)]);

    this.spaceDeclineRefundForm.updateValueAndValidity();
  }

  SetPaymentReversalValues(): void {
    let ii: number;
    let validationMaxAmount: number = 0;
    let parentPaymentId: string = '';
    let referenceNumber: string = '';

    const dateAsString: string = this._datePipe.transform(new Date(), 'MM/dd/yyyy');

    for (ii = 0; ii < this.invoicePayments.length; ii++) {
      if (this.invoicePayments[ii].invoicePaymentID == this.activePaymentAdjustmentId) {
        parentPaymentId = this.invoicePayments[ii].parentPaymentId;
        referenceNumber = this.invoicePayments[ii].referenceNumber;
      }
    }

    validationMaxAmount = this.GetBalancesForInvoicesWithSameParentPaymentId(parentPaymentId);

    try {
      this.paymentReversalForm.reset();

      this.paymentReversalForm = new FormGroup({
        amount: new FormControl('', [Validators.min(0.01)]),
        comment: new FormControl('', [Validators.required]),
        referenceNumber: new FormControl('', [Validators.required]),
        depositDate: new FormControl('', [Validators.required]),
        depositDateAsString: new FormControl('', [Validators.required]),
      });

      this.paymentReversalForm.setValue({
        amount: validationMaxAmount.toLocaleString('en-us', { minimumFractionDigits: 2 }),
        comment: '',
        referenceNumber: referenceNumber,
        depositDate: new Date(),
        depositDateAsString: dateAsString,
      });

      this.paymentReversalForm
        .get('amount')
        .addValidators([
          Validators.required,
          Validators.max(+validationMaxAmount.toLocaleString('en-us', { minimumFractionDigits: 2 })),
          Validators.min(0.01),
        ]);

      this.paymentReversalForm.updateValueAndValidity();
    } catch (err) {
      console.error('Error setting validation amount');
    }
  }

  OnSubmitPaymentReversal(): void {
    this.SetPaymentCreditValues();
  }

  SetPaymentCreditValues(): void {
    let invoiceBalance: number = 0;
    let ii: number;
    let paymentInfo: PaidInvoicePayments;
    let expectedDepositDate: Date;

    for (ii = 0; ii < this.invoicePayments.length; ii++) {
      if (this.invoicePayments[ii].invoicePaymentID == this.activePaymentAdjustmentId) {
        paymentInfo = this.invoicePayments[ii];
        expectedDepositDate = this.invoicePayments[ii].transactionDate;
      }
    }

    //Ken Moss :: 20240729 - removed commas from amount
    let amountAsNumber: number = +this.paymentReversalForm.get('amount').value.toLocaleString().replaceAll(',', '');

    this.pendingDirectDepositPayment.Comments = this.paymentReversalForm.get('comment')!.value;

    if (this.paymentReversalIsAdmin) {
      this.pendingDirectDepositPayment.ExpectedDepositDate = this.paymentReversalForm.get('depositDate')!.value;
    } else {
      this.pendingDirectDepositPayment.ExpectedDepositDate = new Date(
        this.paymentReversalForm.get('depositDateAsString')!.value,
      );
    }

    this.pendingDirectDepositPayment.FilterDescription = paymentInfo.filterDescription;
    this.pendingDirectDepositPayment.HideOnInvoice = false;
    this.pendingDirectDepositPayment.InvoiceNumber = this.invoiceNumber;
    this.pendingDirectDepositPayment.IsLocked = true;
    this.pendingDirectDepositPayment.IsMidnight = false;
    this.pendingDirectDepositPayment.IsRSUpdated = false;
    this.pendingDirectDepositPayment.IsTrainingData = false;
    this.pendingDirectDepositPayment.LotNumber = this.invoiceDetailData.lotNumber;
    this.pendingDirectDepositPayment.PaymentAmount = amountAsNumber * -1;
    this.pendingDirectDepositPayment.PaymentMode = false;
    this.pendingDirectDepositPayment.PaymentType = paymentInfo.paymentCode;
    this.pendingDirectDepositPayment.IsRSUpdated = false;
    this.pendingDirectDepositPayment.PaymentCode = paymentInfo.paymentCode;
    this.pendingDirectDepositPayment.ReferenceNumber = this.paymentReversalForm.get('referenceNumber')!.value;
    this.pendingDirectDepositPayment.Username = this._appGeneralStateService.userName;
    this.pendingDirectDepositPayment.RequestId = 'NULL';
    this.pendingDirectDepositPayment.PaymentStatus = 0;
    this.pendingDirectDepositPayment.PaymentTransactionType = 6;
    this.pendingDirectDepositPayment.ParentPaymentId = this.activePaymentAdjustmentId;

    this.saveNewReversingPaymentWithExpectedTransactionDate(this.pendingDirectDepositPayment);
  }

  saveNewReversingPaymentWithExpectedTransactionDate(
    paymentFormPaymentDate: InvoicePaymentWithExpectedDepositDate,
  ): void {
    let postSucceeded: boolean;

    if (this.paymentsBeingAdded) return;

    this.paymentsBeingAdded = true;

    this.invoiceService.postInvoicePaymentWithExpectedDepositDate(paymentFormPaymentDate).subscribe(
      (resp) => {
        postSucceeded = resp;
      },
      (err: any) => {
        let errorLogEntry: dbErrorEntry = new dbErrorEntry();

        this.paymentsBeingAdded = false;

        errorLogEntry.Location = 'Err: invoice-payments.ts::postInvoicePaymentWithExpectedDepositDate().';
        errorLogEntry.errorMessage = JSON.stringify(err);
        this.apnUtilityService.logErrorToDB(errorLogEntry);

        this.messageService.addExceptionMessage(
          'An error occurred while submitting this payment reversal. Please review the payment data and resubmit. If the error continues to occur, please contact APN Support. Error Id #: ' +
            err.error,
        );
      },
      () => {
        this.paymentsBeingAdded = false;

        this.onResetPaymentData();

        this.getInvoiceDetailBalancesForInvoiceNumber(this.invoiceNumber);

        //Reset pending payment
        this.pendingDirectDepositPayment = new InvoicePaymentWithExpectedDepositDate();

        this._snackBar.open('This payment reversal has been successfully submitted.', '', { duration: 3000 });

        this.getPaymentsForInvoiceNumber(this.invoiceNumber);

        this.showPaymentAdjustment = false;
      },
    );
  }

  /* * * * * * * * * * * * * * *
    END PAYMNET REVERSAL
  * * * * * * * * * * * * * * * */

  /*
    START PAYMENT TRANSFER - WITH TRANSFER TO OTHER INVOICE
  */

  InitPaymentReversalTransferForm(): void {
    this.paymentReversalWithTransferForm = new FormGroup({
      amount: new FormControl('', [Validators.min(0.01)]),
      invoiceNumber: new FormControl('', [Validators.required]),
    });
  }

  OnSubmitPaymentReversalAllocateToOtherInvoice(): void {
    let invoiceBalance: number = 0;
    let ii: number;
    let paymentInfo: PaidInvoicePayments;
    let expectedDepositDate: Date;

    for (ii = 0; ii < this.invoicePayments.length; ii++) {
      if (this.invoicePayments[ii].invoicePaymentID == this.activePaymentAdjustmentId) {
        paymentInfo = this.invoicePayments[ii];
        expectedDepositDate = this.invoicePayments[ii].transactionDate;
      }
    }

    let amountAsNumber: number = +this.paymentReversalWithTransferForm
      .get('amount')
      .value.toLocaleString()
      .replace(',', '');

    this.pendingDirectDepositPayment.Comments =
      'Payment Transfer to ' + this.paymentReversalWithTransferForm.get('invoiceNumber').value;
    this.pendingDirectDepositPayment.ExpectedDepositDate = expectedDepositDate;
    this.pendingDirectDepositPayment.FilterDescription = paymentInfo.filterDescription;
    this.pendingDirectDepositPayment.HideOnInvoice = false;
    this.pendingDirectDepositPayment.InvoiceNumber = this.invoiceNumber;
    this.pendingDirectDepositPayment.IsLocked = true;
    this.pendingDirectDepositPayment.IsMidnight = false;
    this.pendingDirectDepositPayment.IsRSUpdated = false;
    this.pendingDirectDepositPayment.IsTrainingData = false;
    this.pendingDirectDepositPayment.LotNumber = this.invoiceDetailData.lotNumber;
    this.pendingDirectDepositPayment.PaymentAmount = amountAsNumber * -1;
    this.pendingDirectDepositPayment.PaymentMode = false;
    this.pendingDirectDepositPayment.PaymentType = paymentInfo.paymentCode;
    this.pendingDirectDepositPayment.IsRSUpdated = false;
    this.pendingDirectDepositPayment.PaymentCode = paymentInfo.paymentCode;
    this.pendingDirectDepositPayment.ReferenceNumber = paymentInfo.referenceNumber;
    this.pendingDirectDepositPayment.Username = this._appGeneralStateService.userName;
    this.pendingDirectDepositPayment.RequestId = 'NULL';
    this.pendingDirectDepositPayment.PaymentStatus = 0;
    this.pendingDirectDepositPayment.PaymentTransactionType = 2;
    this.pendingDirectDepositPayment.ParentPaymentId = paymentInfo.invoicePaymentID;

    let confirmationData: IConfirmPaymentTransferData = {} as IConfirmPaymentTransferData;
    confirmationData.amount = (this.pendingDirectDepositPayment.PaymentAmount * -1).toLocaleString();
    confirmationData.invoiceNumber = this.paymentReversalWithTransferForm.get('invoiceNumber').value;

    const dialogConfirmProceedWithTransfer = this.dialog.open(ConfirmTransferPaymentComponent, {
      data: confirmationData,
    });

    dialogConfirmProceedWithTransfer.afterClosed().subscribe((result) => {
      if (result) {
        this.saveNewReversingPaymentToDb(this.pendingDirectDepositPayment);
      }
    });

    //this.saveNewReversingPaymentWithExpectedTransactionDate(this.pendingDirectDepositPayment);
  }

  OnSubmitPaymentReversalForTransfer(): void {
    let invoiceBalance: number = 0;
    let ii: number;
    let paymentInfo: PaidInvoicePayments;
    let expectedDepositDate: Date;

    for (ii = 0; ii < this.invoicePayments.length; ii++) {
      if (this.invoicePayments[ii].invoicePaymentID == this.activePaymentAdjustmentId) {
        paymentInfo = this.invoicePayments[ii];
        expectedDepositDate = this.invoicePayments[ii].transactionDate;
      }
    }

    this.pendingDirectDepositPayment.Comments = 'Payment Transfer from ' + this.invoiceNumber;
    this.pendingDirectDepositPayment.ExpectedDepositDate = expectedDepositDate;
    this.pendingDirectDepositPayment.FilterDescription = paymentInfo.filterDescription;
    this.pendingDirectDepositPayment.HideOnInvoice = false;
    this.pendingDirectDepositPayment.InvoiceNumber = this.paymentReversalWithTransferForm.get('invoiceNumber').value;
    this.pendingDirectDepositPayment.IsLocked = true;
    this.pendingDirectDepositPayment.IsMidnight = false;
    this.pendingDirectDepositPayment.IsRSUpdated = false;
    this.pendingDirectDepositPayment.IsTrainingData = false;
    this.pendingDirectDepositPayment.LotNumber = this.invoiceDetailData.lotNumber;
    this.pendingDirectDepositPayment.PaymentAmount =
      +this.paymentReversalWithTransferForm.get('amount').value.replace(',', '') * -1;
    this.pendingDirectDepositPayment.PaymentMode = false;
    this.pendingDirectDepositPayment.PaymentType = paymentInfo.paymentCode;
    this.pendingDirectDepositPayment.IsRSUpdated = false;
    this.pendingDirectDepositPayment.PaymentCode = paymentInfo.paymentCode;
    this.pendingDirectDepositPayment.ReferenceNumber = paymentInfo.referenceNumber;
    this.pendingDirectDepositPayment.Username = this._appGeneralStateService.userName;

    this.saveNewReversingPaymentToDb(this.pendingDirectDepositPayment);
  }

  OnSubmitPaymentReversalTargetInvoice(): void {
    let invoiceBalance: number = 0;

    let ii: number;
    let paymentInfo: PaidInvoicePayments;
    let expectedDepositDate: Date;

    for (ii = 0; ii < this.invoicePayments.length; ii++) {
      if (this.invoicePayments[ii].invoicePaymentID == this.activePaymentAdjustmentId) {
        paymentInfo = this.invoicePayments[ii];
        expectedDepositDate = this.invoicePayments[ii].transactionDate;
      }
    }

    let amountAsNumber: number = +this.paymentReversalWithTransferForm
      .get('amount')
      .value.toLocaleString()
      .replace(',', '');

    this.pendingDirectDepositPayment.Comments = 'Payment Transfer from ' + this.invoiceNumber;
    this.pendingDirectDepositPayment.ExpectedDepositDate = expectedDepositDate;
    this.pendingDirectDepositPayment.FilterDescription = paymentInfo.filterDescription;
    this.pendingDirectDepositPayment.HideOnInvoice = false;
    this.pendingDirectDepositPayment.InvoiceNumber = this.paymentReversalWithTransferForm.get('invoiceNumber').value;
    this.pendingDirectDepositPayment.IsLocked = true;
    this.pendingDirectDepositPayment.IsMidnight = false;
    this.pendingDirectDepositPayment.IsRSUpdated = false;
    this.pendingDirectDepositPayment.IsTrainingData = false;
    this.pendingDirectDepositPayment.LotNumber = this.invoiceDetailData.lotNumber;
    this.pendingDirectDepositPayment.PaymentAmount = amountAsNumber;
    this.pendingDirectDepositPayment.PaymentMode = false;
    this.pendingDirectDepositPayment.PaymentType = paymentInfo.paymentCode;
    this.pendingDirectDepositPayment.IsRSUpdated = false;
    this.pendingDirectDepositPayment.PaymentCode = paymentInfo.paymentCode;
    this.pendingDirectDepositPayment.ReferenceNumber = paymentInfo.referenceNumber;
    this.pendingDirectDepositPayment.Username = this._appGeneralStateService.userName;
    this.pendingDirectDepositPayment.RequestId = 'NULL';
    this.pendingDirectDepositPayment.PaymentStatus = 0;
    this.pendingDirectDepositPayment.PaymentTransactionType = 3;

    this.saveNewReversingWithInvoiceTransferPaymentToDb(this.pendingDirectDepositPayment);
  }

  SetPaymentReversalTransferValues(): void {
    let ii: number;
    let invoicePaymentBalance: number = 0;
    let referenceNumber: string = '';
    let currentInvoiceBalance: number = 0;
    let selectedInvoiceBalance: number = 0;
    let formBalance: number = 0;
    let parentPaymentId: string = '';

    let selectedInvoiceNumber = this.paymentReversalWithTransferForm.get('invoiceNumber')!.value;

    for (ii = 0; ii < this.invoicePayments.length; ii++) {
      if (this.invoicePayments[ii].invoicePaymentID == this.activePaymentAdjustmentId) {
        referenceNumber = this.invoicePayments[ii].referenceNumber;
        parentPaymentId = this.invoicePayments[ii].parentPaymentId;
      }
    }

    for (ii = 0; ii < this.invoicePayments.length; ii++) {
      if (this.invoicePayments[ii].parentPaymentId == parentPaymentId) {
        invoicePaymentBalance = invoicePaymentBalance + +this.invoicePayments[ii].amount;
      }
    }

    for (ii = 0; ii < this.invoiceBalanceList.length; ii++) {
      if (this.invoiceBalanceList[ii].invoiceNumber == selectedInvoiceNumber) {
        selectedInvoiceBalance = this.invoiceBalanceList[ii].currentBalance;
      }
    }

    if (selectedInvoiceBalance < invoicePaymentBalance) formBalance = selectedInvoiceBalance;
    else formBalance = invoicePaymentBalance;

    this.paymentReversalWithTransferForm.reset();
    this.paymentReversalWithTransferForm = new FormGroup({
      amount: new FormControl('', [Validators.min(0.01)]),
      invoiceNumber: new FormControl('', [Validators.required]),
    });

    this.paymentReversalWithTransferForm.setValue({
      amount: formBalance,
      invoiceNumber: selectedInvoiceNumber,
    });

    this.paymentReversalWithTransferForm.clearValidators();

    this.paymentReversalWithTransferForm
      .get('amount')
      .addValidators([Validators.required, Validators.max(invoicePaymentBalance)]);

    this.paymentReversalWithTransferForm.updateValueAndValidity();
  }

  OnResetPaymentReversalTransferForm(): void {
    this.paymentReversalWithTransferForm.patchValue({
      invoiceNumber: '',
      amount: '',
    });
    //this.SetPaymentReversalTransferValues();
  }

  saveNewReversingPaymentToDb(paymentFormPaymentDate: InvoicePaymentWithExpectedDepositDate): void {
    let postSucceeded: boolean;

    if (this.paymentsBeingAdded) return;

    this.paymentsBeingAdded = true;

    this.invoiceService.postInvoicePaymentWithExpectedDepositDate(paymentFormPaymentDate).subscribe(
      (resp) => {
        postSucceeded = resp;
      },
      (err: any) => {
        let errorLogEntry: dbErrorEntry = new dbErrorEntry();

        this.paymentsBeingAdded = false;

        this.showPaymentAdjustment = false;

        errorLogEntry.Location = 'Err: invoice-payments.ts::postInvoicePaymentWithExpectedDepositDate().';
        errorLogEntry.errorMessage = JSON.stringify(err);
        this.apnUtilityService.logErrorToDB(errorLogEntry);

        this.messageService.addExceptionMessage(
          'An error occurred while submitting this payment reversal. Please review the payment data and resubmit. If the error continues to occur, please contact APN Support. Error Id #: ' +
            err.error,
        );
      },
      () => {
        this.paymentsBeingAdded = false;

        //this.addNewDeposit();

        this.onResetPaymentData();

        this.getInvoiceDetailBalancesForInvoiceNumber(this.invoiceNumber);

        //Reset pending payment
        this.pendingDirectDepositPayment = new InvoicePaymentWithExpectedDepositDate();

        //this._snackBar.open('This payment reversal has been successfully submitted.', '', {duration:3000});
        this.OnSubmitPaymentReversalTargetInvoice();

        this.getPaymentsForInvoiceNumber(this.invoiceNumber);
      },
    );
  }

  saveNewReversingWithInvoiceTransferPaymentToDb(paymentFormPaymentDate: InvoicePaymentWithExpectedDepositDate): void {
    let postSucceeded: boolean;

    if (this.paymentsBeingAdded) return;

    this.paymentsBeingAdded = true;

    this.invoiceService.postInvoicePaymentWithExpectedDepositDate(paymentFormPaymentDate).subscribe(
      (resp) => {
        postSucceeded = resp;
      },
      (err: any) => {
        let errorLogEntry: dbErrorEntry = new dbErrorEntry();

        this.paymentsBeingAdded = false;

        this.showPaymentAdjustment = false;

        errorLogEntry.Location = 'Err: invoice-payments.ts::postInvoicePaymentWithExpectedDepositDate().';
        errorLogEntry.errorMessage = JSON.stringify(err);
        this.apnUtilityService.logErrorToDB(errorLogEntry);

        this.messageService.addExceptionMessage(
          'An error occurred while submitting this payment reversal. Please review the payment data and resubmit. If the error continues to occur, please contact APN Support. Error Id #: ' +
            err.error,
        );
      },
      () => {
        this.paymentsBeingAdded = false;

        //this.addNewDeposit();

        this.onResetPaymentData();

        this.getInvoiceDetailBalancesForInvoiceNumber(this.invoiceNumber);

        //Reset pending payment
        this.pendingDirectDepositPayment = new InvoicePaymentWithExpectedDepositDate();

        //this._snackBar.open('This payment reversal has been successfully submitted.', '', {duration:3000});

        this.showPaymentAdjustment = false;
      },
    );
  }

  /* * * * * * * * * * * * * * *
    END PAYMENT REVERSAL WITH TRANSFER
  * * * * * * * * * * * * * * * */

  OnCloseAllOtherPaymentForms(): void {
    this.showRefundWorkflowForm = false;
    this.showPaymentAdjustment = false;
    this.showDeclineRefundWorkflowForm = false;
  }

  ngOnChanges(changes: SimpleChanges): void {}

  ngOnDestroy(): void {
    this.subInvoiceDetail.unsubscribe();
  }

  initDataforInvoicePayment(invoiceNumber: string): void {
    this.isGB = this.isInvoiceGBType(invoiceNumber);

    this.getInvoiceDetailBalancesForInvoiceNumber(invoiceNumber);

    this.getPaymentsForInvoiceNumber(invoiceNumber);
  }

  addNewPaymentFormPayment() {
    this.setPaymentFormPaymentData();

    let pendingNewBalance: number;

    pendingNewBalance = this.msgService.currentInvoiceBalance - this.pendingDirectDepositPayment.PaymentAmount;

    this.saveNewPayment();
  }

  isValueNegative(): boolean {
    let paymentAsString: string;
    let paymentAmount: number;
    try {
      paymentAsString = (<HTMLInputElement>document.getElementById('pmtAmount')).value;
      paymentAmount = this.parseFloatIgnoreCommas(paymentAsString);
    } catch (err) {
      paymentAmount = 0;
    }

    return paymentAmount < 0;
  }

  saveNewPayment() {
    if (
      this.pendingDirectDepositPayment.PaymentAmount > 0 ||
      this._appGeneralStateService.isPaymentRefundOverrideActive
    ) {
      //this is not a refund or override = true
      this.showWaitBanner('Please wait, saving new payment...');
      this.saveNewPaymentWithExpectedTransactionDate(this.pendingDirectDepositPayment);
    }
  }

  setPaymentFormPaymentData() {
    this.pendingDirectDepositPayment.Comments = this.getPaymentFormPaymentComment();
    this.pendingDirectDepositPayment.ExpectedDepositDate = this.formatAceDate(this.paymentFormDepositDate);
    this.pendingDirectDepositPayment.FilterDescription = this.getPaymentFormPaymentTypeText();
    this.pendingDirectDepositPayment.HideOnInvoice = false;
    this.pendingDirectDepositPayment.InvoiceNumber = this.invoiceNumber;
    this.pendingDirectDepositPayment.IsLocked = true;
    this.pendingDirectDepositPayment.IsMidnight = false;
    this.pendingDirectDepositPayment.IsRSUpdated = false;
    this.pendingDirectDepositPayment.IsTrainingData = false;
    this.pendingDirectDepositPayment.LotNumber = this.invoiceDetailData.lotNumber;
    this.pendingDirectDepositPayment.PaymentAmount = this.getPaymentFormPaymentAmount();
    this.pendingDirectDepositPayment.PaymentMode = false;
    this.pendingDirectDepositPayment.PaymentType = this.getPaymentFormPaymentTypeText();
    this.pendingDirectDepositPayment.IsRSUpdated = false;
    this.pendingDirectDepositPayment.PaymentCode = this.getPaymentFormPaymentCode();
    this.pendingDirectDepositPayment.ReferenceNumber = this.getPaymentFormReferenceNumber();
    this.pendingDirectDepositPayment.Username = this._appGeneralStateService.userName;
    this.pendingDirectDepositPayment.RequestId = 'NULL';
    this.pendingDirectDepositPayment.PaymentStatus = 0;
    this.pendingDirectDepositPayment.PaymentTransactionType = 0;
  }

  getPaymentsForInvoiceNumber(invoiceNumber: string) {
    this.invoiceService.getPaymentListForInvoiceNumber(invoiceNumber).subscribe(
      (paymentTypeList) => {
        this.invoicePayments = paymentTypeList;
      },
      (err: any) => {
        let errorLogEntry: dbErrorEntry = new dbErrorEntry();

        errorLogEntry.Location = 'Err: invoice-payments.ts::getPaymentsForInvoiceNumber().';
        errorLogEntry.errorMessage = JSON.stringify(err);
        this.apnUtilityService.logErrorToDB(errorLogEntry);
      },
      () => {},
    );
  }

  saveNewPaymentWithExpectedTransactionDate(paymentFormPaymentDate: InvoicePaymentWithExpectedDepositDate): void {
    let postSucceeded: boolean;

    if (this.paymentsBeingAdded) return;

    this.paymentsBeingAdded = true;

    this.invoiceService.postInvoicePaymentWithExpectedDepositDate(paymentFormPaymentDate).subscribe(
      (resp) => {
        postSucceeded = resp;
      },
      (err: any) => {
        let errorLogEntry: dbErrorEntry = new dbErrorEntry();

        this.paymentsBeingAdded = false;

        errorLogEntry.Location = 'Err: invoice-payments.ts::postInvoicePaymentWithExpectedDepositDate().';
        errorLogEntry.errorMessage = JSON.stringify(err);
        this.apnUtilityService.logErrorToDB(errorLogEntry);

        this.messageService.addExceptionMessage(
          'An error occurred while submitting this payment. Please review the payment data and resubmit. If the error continues to occur, please contact APN Support. Error Id #: ' +
            err.error,
        );
      },
      () => {
        this.paymentsBeingAdded = false;

        //this.addNewDeposit();

        this.onResetPaymentData();

        this.getInvoiceDetailBalancesForInvoiceNumber(this.invoiceNumber);

        this.getPaymentsForInvoiceNumber(this.invoiceNumber);

        //Reset pending payment
        this.pendingDirectDepositPayment = new InvoicePaymentWithExpectedDepositDate();

        this.hideWaitShowSuccessBanner('The payment has been submitted successfully');
        // this.hideWaitBanner();

        // this._dialogService.snackBarTopCenterTimed('This payment has been submitted.', 3000);
      },
    );
  }

  getCurrentDate(): any {
    var today = new Date();
    var returnDate = '';

    var dd = today.getDate();
    var mm = today.getMonth() + 1;
    var yyyy = today.getFullYear();

    returnDate += `${mm}/${dd}/${yyyy}`;

    return returnDate;
  }

  onPaymentChangeForm() {
    try {
      //If this is the title value, then clear reference input element
      if ('0' === (<HTMLOptionElement>document.getElementById('pmtSelectPaymentType')).value) {
        this.referenceNumberPlaceholderForm = '';
      }

      var e = document.getElementById('pmtSelectPaymentType') as HTMLSelectElement;
      var sel = e.selectedIndex;
      var opt = e.options[sel];
      var paymentTypeText = (<HTMLOptionElement>opt).text;

      if (paymentTypeText.toUpperCase() === 'CASH') {
        this.referenceNumberPlaceholderForm = '########';
      }

      if (paymentTypeText.toUpperCase() === 'AMEX') {
        this.referenceNumberPlaceholderForm = '####';
      }

      if (paymentTypeText.toUpperCase() === 'CHECK') {
        this.referenceNumberPlaceholderForm = '########-####';
      }

      // 20250912 :: Ken Moss :: Chnnged Refund Payment from 8-3 to 8 characters
      if (paymentTypeText.toUpperCase() === 'REFUND PAYMENT') {
        this.referenceNumberPlaceholderForm = '########';
      }

      if (paymentTypeText.toUpperCase() === 'DISCOVER') {
        this.referenceNumberPlaceholderForm = '####';
      }

      if (paymentTypeText.toUpperCase() === 'DINERS CLUB') {
        this.referenceNumberPlaceholderForm = '####';
      }

      if (paymentTypeText.toUpperCase() === 'APN SPACE PAYMENT') {
        this.referenceNumberPlaceholderForm = 'Up to 32 Characters';
      }

      if (paymentTypeText.toUpperCase() === 'VISA MC') {
        this.referenceNumberPlaceholderForm = '####';
      }

      if (paymentTypeText.toUpperCase() === 'OPTIMA') {
        this.referenceNumberPlaceholderForm = '####';
      }

      if (paymentTypeText.toUpperCase() === 'AMEXP') {
        this.referenceNumberPlaceholderForm = '####';
      }

      if (paymentTypeText.toUpperCase() === 'CC-OTHER') {
        this.referenceNumberPlaceholderForm = '####';
      }

      if (this.referenceNumberPlaceholderForm == '') this.referenceNumberPlaceholderForm = '########';

      //reset all input variables and disable submit button
      (<HTMLInputElement>document.getElementById('pmtAmount')).value = '';
      (<HTMLInputElement>document.getElementById('pmtReferenceNumber')).value = '';
      this.paymentFormDepositDate = '';
      (<HTMLInputElement>document.getElementById('pmtComment')).value = '';

      //clear validation messages
      this.paymentValidationMessages.paymentAmountMessage = '';
      this.paymentValidationMessages.referenceNumberMessage = '';
      this.paymentValidationMessages.dateMessage = '';
      this.paymentValidationMessages.invalidCharactersReferenceNumber = '';

      //Set Submit button for payment to disabled
      this.paymentDataIsInvalid = true;
    } catch (err) {
      console.error('onPaymentChange Error: ' + err);
    }
  }

  //Reset input elements/select dropdowns to initial values on payment form
  onResetPaymentData(): void {
    try {
      this.refNumberErrorCount = 0;
      (<HTMLInputElement>document.getElementById('pmtAmount')).value = '';
      (<HTMLInputElement>document.getElementById('pmtReferenceNumber')).value = '';
      this.paymentFormDepositDate = '';
      (<HTMLInputElement>document.getElementById('pmtComment')).value = '';
      (<HTMLOptionElement>document.getElementById('pmtSelectPaymentType')).value = '0';
    } catch (err) {
      console.error(err);
    }
  }

  IsPaymentDescriptionANegativePaymentException(paymentTypeText: string): boolean {
    let isException: boolean = false;
    let ii: number = 0;

    // this._appGeneralStateService.isPaymentRefundOverrideActive = false; //reset this every time

    for (ii = 0; ii < this.negativePaymentExceptionList.length; ii++) {
      if (this.negativePaymentExceptionList[ii].trim().toUpperCase() == paymentTypeText.trim().toUpperCase()) {
        isException = true;
        // this._appGeneralStateService.isPaymentRefundOverrideActive = true;
      }
    }

    return isException;
  }

  IsExceptionPaymentAmountValid(): boolean {
    let paymentAmount: string = '';
    this.paymentValidationMessages.isInvalid = false;

    try {
      paymentAmount = (<HTMLInputElement>document.getElementById('pmtAmount')).value;

      if (paymentAmount === '') {
        this.paymentValidationMessages.isInvalid = true;
        this.paymentValidationMessages.paymentAmountMessage = 'Payment cannot be $0';
        return false;
      }

      if (paymentAmount === '0') {
        this.paymentValidationMessages.isInvalid = true;
        this.paymentValidationMessages.paymentAmountMessage = 'Payment cannot be $0';
        return false;
      }

      if (+paymentAmount < -99999.99) {
        this.paymentValidationMessages.isInvalid = true;
        this.paymentValidationMessages.paymentAmountMessage = 'Payment must be more than -$100,000';
        return false;
      } else if (+paymentAmount > 99999.99) {
        this.paymentValidationMessages.isInvalid = true;
        this.paymentValidationMessages.paymentAmountMessage = 'Payment must be less than $100,000';
        return false;
      } else this.paymentValidationMessages.paymentAmountMessage = '';
    } catch (err) {
      return false;
    }

    return true;
  }

  setPaymentDataValidStatus(): void {
    let isInvalid: boolean = false;

    var e = document.getElementById('pmtSelectPaymentType') as HTMLSelectElement;
    var sel = e.selectedIndex;
    var opt = e.options[sel];
    let paymentTypeText: string = (<HTMLOptionElement>opt).text;

    let theDate: string = this.paymentFormDepositDate;

    try {
      /* * * * * * *
      Author: Ken Moss
      Date: 20240104
      
      Per request from Josh Izigzon, added method to check a list of domain values and if they match the payment description,
      then enable the payment form to accept negative values.
      

      * * * * * * * */
      let isPaymentDescriptionOnExceptionList: boolean =
        this.IsPaymentDescriptionANegativePaymentException(paymentTypeText);

      if (isPaymentDescriptionOnExceptionList) {
        isInvalid = false;
        this.paymentValidationMessages.isInvalid = false;
        this.paymentValidationMessages.dateMessage = '';
        this.paymentValidationMessages.comment = ''; //reset coment message;

        if (isInvalid == false) {
          let referenceNumber: string = (<HTMLInputElement>document.getElementById('pmtReferenceNumber')).value;
          if (referenceNumber.length == 0) {
            this.paymentValidationMessages.isInvalid = true;
            this.paymentValidationMessages.referenceNumberMessage = 'Reference Number Required';
            isInvalid = true;
          } else {
            isInvalid = false;
            this.paymentValidationMessages.isInvalid = false;
            this.paymentValidationMessages.referenceNumberMessage = '';
          }
        }

        if (this.isValidDate(theDate) === false) {
          isInvalid = true;
          this.paymentValidationMessages.isInvalid = true;
          this.paymentValidationMessages.dateMessage = 'Please enter a valid date';
        }

        const paymentValid: boolean = this.IsExceptionPaymentAmountValid();

        if (!paymentValid) isInvalid = true;

        const comments: string = this.getPaymentFormPaymentComment();

        if (comments.length <= 0) {
          isInvalid = true;
          this.paymentValidationMessages.comment = 'This payment type requires a comment';
          this.paymentValidationMessages.isInvalid;
        }

        // END Addition on 20240104
      } else {
        //reset validation flag/messages
        this.paymentValidationMessages.isInvalid = false;
        this.paymentValidationMessages.dateMessage = '';
        this.paymentValidationMessages.comment = ''; //reset coment message;
        if (this.isPaymentFormReferenceNumberValid() == false) {
          isInvalid = true;
        } else {
          let referenceNumber: string = (<HTMLInputElement>document.getElementById('pmtReferenceNumber')).value;
          const checkRef: IRestrictedCharsError = this.formatReferenceNumber(referenceNumber);

          if (checkRef.restrictedChars !== '') {
            if (this.refNumberErrorCount == 0) {
              this.paymentValidationMessages.invalidCharactersReferenceNumber = 'Invalid Characters Entered';
              this.refNumberErrorCount++;
              this.displayInvalidReferenceNumberDialog(checkRef);
            }
            isInvalid = true;
            this.isPaymentFormReferenceNumberValid();
          } else {
            this.paymentValidationMessages.invalidCharactersReferenceNumber = '';
          }
        }
        if ((<HTMLOptionElement>document.getElementById('pmtSelectPaymentType')).value === '0') {
          isInvalid = true;
        }

        if (this.isValidDate(theDate) === false) {
          isInvalid = true;
          this.paymentValidationMessages.isInvalid = true;
          this.paymentValidationMessages.dateMessage = 'Please enter a valid date';
        }

        if (this.isPaymentFormPaymentAmountValid() == false) {
          isInvalid = true;
        }
      }

      const paymentAmountRaw: any = (<HTMLOptionElement>document.getElementById('pmtAmount')).value;
      const paymentAmountAsNumber: number = +paymentAmountRaw;

      if (paymentAmountAsNumber >= 1000000) {
        isInvalid = true;
        this.messageDialogService.snackBarTopCenterTimed('The payment amount cannot exceed $999,999.99.', 5000);
        (<HTMLOptionElement>document.getElementById('pmtAmount')).value = '0';
      }

      this.paymentDataIsInvalid = isInvalid;
    } catch (err) {}
  }

  onKeyPressedReferenceNumber(keyValue: any): void {
    const restrictedStringList = '`";:<>?/!@#$%^&*()_+=';
    const restrictedChars = [...restrictedStringList];
    var restrictedKeyFound: boolean = false;
    var ii: number;
    let restrictedKeyValue: string = '';

    for (ii = 0; ii < restrictedChars.length; ii++) {
      if (keyValue.key.includes(restrictedChars[ii])) {
        restrictedKeyValue = keyValue.key;
        restrictedKeyFound = true;
        break;
      }
    }

    if (restrictedKeyFound) {
      this._messageDialogService.snackBarTopCenterTimed(
        `A restricted key has been entered and is prohibited in the reference number.  Key: ${restrictedKeyValue}`,
        5000,
      );
    }
  }

  formatReferenceNumber(referenceNumber: string): IRestrictedCharsError {
    const restrictedStringList = '`";:<>?/!@#$%^&*()_+=';
    const restrictedChars = [...restrictedStringList];
    var ii: number;
    var invalidCharsFound: string = '';
    var resturnData: IRestrictedCharsError = {} as IRestrictedCharsError;

    for (ii = 0; ii < restrictedChars.length; ii++) {
      if (referenceNumber.includes(restrictedChars[ii])) {
        invalidCharsFound += restrictedChars[ii];
      }
      referenceNumber = referenceNumber.replace(restrictedChars[ii], '');
    }

    resturnData.checkedReferenceNumber = referenceNumber;
    resturnData.restrictedChars = invalidCharsFound;

    return resturnData;
  }

  displayInvalidReferenceNumberDialog(dialogData: IRestrictedCharsError) {
    const dialogRef = this.dialog.open(DialogInvalidReferenceNumberComponent, {
      data: { checkedReferenceNumber: dialogData.checkedReferenceNumber, restrictedChars: dialogData.restrictedChars },
      minWidth: '600px',
      minHeight: '400px',
    });

    dialogRef.afterClosed().subscribe((result) => {});
  }

  isValidDate(dateString: string): boolean {
    let isValidDate: boolean = true;

    try {
      var theTimeStamp = Date.parse(dateString);

      if (isNaN(theTimeStamp) === true) {
        isValidDate = false;
      }
    } catch (error) {
      isValidDate = false;
    }

    return isValidDate;
  }

  isFormat8Dash4ReferenceNumberValid(referenceNumber: string): boolean {
    let isValid: boolean = true; //assume true and return false if error condition

    if (referenceNumber.length !== 13) {
      this.paymentValidationMessages.referenceNumberMessage = '13 characters required(########-####)';
      return false;
    }

    let dashChar: string = referenceNumber.substring(8, 9);
    if (dashChar !== '-' || dashChar !== '-') {
      this.paymentValidationMessages.referenceNumberMessage = 'Dash is required(########-####)';
      return false;
    }

    return isValid;
  }

  isPaymentFormReferenceNumberValid(): boolean {
    var e = document.getElementById('pmtSelectPaymentType') as HTMLSelectElement;
    var sel = e.selectedIndex;
    var opt = e.options[sel];
    let paymentTypeText: string = (<HTMLOptionElement>opt).text;

    let referenceNumber: string = (<HTMLInputElement>document.getElementById('pmtReferenceNumber')).value;

    this.paymentValidationMessages.referenceNumberMessage = ''; //reset

    //Check if the payment override is enabled/set to true.
    //If it is set to true, then ignore all other validation and enforce more than 1, but less than 32 alpha numeric characters
    if (this._appGeneralStateService.isPaymentRefundOverrideActive) {
      if (referenceNumber.length < 1 || referenceNumber.length > 32) {
        // 1 <= n <= 32
        this.paymentValidationMessages.isInvalid = true;
        this.paymentValidationMessages.referenceNumberMessage = '32 chars max';
        return false;
      }
    } else {
      if (paymentTypeText.toUpperCase() === 'AMEX') {
        if (referenceNumber.length === 4) return true;
        else {
          this.paymentValidationMessages.isInvalid = true;
          this.paymentValidationMessages.referenceNumberMessage = '4 characters (####))';
          return false;
        }
      }

      if (paymentTypeText.toUpperCase() === 'VISA/MC') {
        if (referenceNumber.length === 4) return true;
        else {
          this.paymentValidationMessages.isInvalid = true;
          this.paymentValidationMessages.referenceNumberMessage = '4 characters (####))';
          return false;
        }
      }

      if (paymentTypeText.toUpperCase() === 'APN SPACE PAYMENT') {
        if (referenceNumber.length <= 32) return true;
        else {
          this.paymentValidationMessages.isInvalid = true;
          this.paymentValidationMessages.referenceNumberMessage = 'Up to 32 characters';
          return false;
        }
      }

      if (paymentTypeText.toUpperCase() === 'CHECK') {
        if (this.isFormat8Dash4ReferenceNumberValid(referenceNumber) === true) return true;
        else {
          this.paymentValidationMessages.isInvalid = true;
          return false;
        }
      }

      if (paymentTypeText.toUpperCase() === 'REFUND PAYMENT') {
        if (referenceNumber.length === 8) return true;
        else {
          this.paymentValidationMessages.isInvalid = true;
          this.paymentValidationMessages.referenceNumberMessage = '8 characters (########)';
          return false;
        }
      }

      if (paymentTypeText.toUpperCase() === 'DISCOVER') {
        if (referenceNumber.length === 4) return true;
        else {
          this.paymentValidationMessages.isInvalid = true;
          this.paymentValidationMessages.referenceNumberMessage = '4 characters (####))';
          return false;
        }
      }

      if (paymentTypeText.toUpperCase() === 'DINERS CLUB') {
        if (referenceNumber.length === 4) return true;
        else {
          this.paymentValidationMessages.isInvalid = true;
          this.paymentValidationMessages.referenceNumberMessage = '4 characters (####)';
          return false;
        }
      }

      if (paymentTypeText.toUpperCase() === 'VISA MC') {
        if (referenceNumber.length === 4) return true;
        else {
          this.paymentValidationMessages.isInvalid = true;
          this.paymentValidationMessages.referenceNumberMessage = '4 characters (####) ';
          return false;
        }
      }

      if (paymentTypeText.toUpperCase() === 'AMEXP') {
        if (referenceNumber.length === 4) return true;
        else {
          this.paymentValidationMessages.isInvalid = true;
          this.paymentValidationMessages.referenceNumberMessage = '4 characters (####) ';
          return false;
        }
      }

      if (paymentTypeText.toUpperCase() === 'CC-OTHER') {
        if (referenceNumber.length === 4) return true;
        else {
          this.paymentValidationMessages.isInvalid = true;
          this.paymentValidationMessages.referenceNumberMessage = '4 characters (####) ';
          return false;
        }
      }

      if (paymentTypeText.toUpperCase() === 'OPTIMA') {
        if (referenceNumber.length === 4) return true;
        else {
          this.paymentValidationMessages.isInvalid = true;
          this.paymentValidationMessages.referenceNumberMessage = '4 characters (####) ';
          return false;
        }
      }

      if (paymentTypeText.toUpperCase() === 'CASH') {
        if (referenceNumber.length === 8) return true;
        else {
          this.paymentValidationMessages.isInvalid = true;
          this.paymentValidationMessages.referenceNumberMessage = '8 characters (########)';
          return false;
        }
      }

      //all other reference types must be 8 characters long
      if (referenceNumber.length === 8) return true;
      else {
        this.paymentValidationMessages.isInvalid = true;
        this.paymentValidationMessages.referenceNumberMessage = '8 characters (########)';
        return false;
      }
    }

    return true;
  }

  isPaymentFormPaymentAmountValid(): boolean {
    let paymentAmount: string = '';

    try {
      paymentAmount = (<HTMLInputElement>document.getElementById('pmtAmount')).value;

      if (paymentAmount === '') {
        return false;
      }

      if (paymentAmount === '0') {
        return false;
      }

      if (+paymentAmount <= 0) {
        this.paymentValidationMessages.isInvalid = true;
        this.paymentValidationMessages.paymentAmountMessage = 'Payment must be greater than $0';
        return false;
      } else this.paymentValidationMessages.paymentAmountMessage = '';
    } catch (err) {
      return false;
    }

    return true;
  }

  isRefund(): boolean {
    let isRefund: boolean = false;
    let paymentAmount: string = '';

    paymentAmount = (<HTMLInputElement>document.getElementById('pmtAmount')).value;

    if (paymentAmount === '') {
      return false;
    }

    if (paymentAmount === '0') {
      return false;
    }

    try {
      let refundTestAmount: number = this.parseFloatIgnoreCommas(paymentAmount);
      if (refundTestAmount < 0) isRefund = true;
    } catch (err) {
      return false;
    }

    return isRefund;
  }

  getPaymentFormPaymentComment(): string {
    let pmtComment: string = (<HTMLInputElement>document.getElementById('pmtComment')).value;

    return pmtComment;
  }

  formatAceDate(dateToPrepare: string): Date {
    let formattedDate: Date = new Date();

    if (dateToPrepare !== '') {
      formattedDate = new Date(formatDate(new Date(dateToPrepare), 'MM-dd-yyyy', 'en-US'));
    }

    return formattedDate;
  }

  getPaymentFormPaymentTypeText(): string {
    let paymentTypeText: string;

    var e = document.getElementById('pmtSelectPaymentType') as HTMLSelectElement;
    var sel = e.selectedIndex;
    var opt = e.options[sel];
    paymentTypeText = (<HTMLOptionElement>opt).text;

    return paymentTypeText;
  }

  getPaymentFormPaymentAmount(): number {
    let paymentAsString: string = (<HTMLInputElement>document.getElementById('pmtAmount')).value;
    let paymentAmount: number = this.parseFloatIgnoreCommas(paymentAsString);

    return paymentAmount;
  }

  getPaymentFormReferenceNumber(): string {
    let paymentReferenceNumber: string = (<HTMLInputElement>document.getElementById('pmtReferenceNumber')).value;

    return paymentReferenceNumber;
  }

  getPaymentFormPaymentCode(): string {
    let paymentCode: string;

    var e = document.getElementById('pmtSelectPaymentType') as HTMLSelectElement;
    var sel = e.selectedIndex;
    var opt = e.options[sel];
    paymentCode = (<HTMLOptionElement>opt).value;

    return paymentCode;
  }

  // addNewDeposit(){
  //   this.invoicePayments.push({
  //     invoicePaymentID: '',
  //     paymentCode: this.pendingDirectDepositPayment.PaymentCode,
  //       lotNumber: this.pendingDirectDepositPayment.LotNumber,
  //       invoiceNumber: this.pendingDirectDepositPayment.InvoiceNumber,
  //       referenceNumber: this.pendingDirectDepositPayment.ReferenceNumber,
  //       amount: this.pendingDirectDepositPayment.PaymentAmount.toString(),
  //       transactionDate: this.pendingDirectDepositPayment.ExpectedDepositDate,
  //       comments: this.pendingDirectDepositPayment.Comments,
  //       dateGenerated: this.getCurrentDate(),
  //       filterDescription: this.pendingDirectDepositPayment.FilterDescription,
  //       transactionID: '',

  //   })
  // }

  parseFloatIgnoreCommas(theNumber: string): number {
    var numberNoCommas = theNumber.replace(/,/g, '');
    return parseFloat(numberNoCommas);
  }

  isInvoiceGBType(invoiceNumber: string): boolean {
    let isGB: boolean;

    if (invoiceNumber.length === 0) isGB = false;

    if (invoiceNumber.substring(0, 2) === 'GB') isGB = true;
    else isGB = false;

    return isGB;
  }

  setInvoiceDetailData(): void {
    let ii: number = 0;

    try {
      this.invoiceNumber = this.invoiceDetailData.invoiceNumber;
      this.invoiceAmount = this.invoiceDetailData.rate;
      this.invoiceBalance = this.invoiceDetailData.currentBalance;

      this.msgService.currentInvoiceBalance = this.invoiceBalance;

      if (this.invoiceDetailData.customerName !== '') this.customerName = this.invoiceDetailData.customerName;
      else this.customerName = this.invoiceDetailData.companyName;

      var months = [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December',
      ];
      var d = new Date(this.invoiceDetailData.invoiceDate);
      var monthName = months[d.getMonth()];
      var year = d.getFullYear();

      this.invoicePeriod = monthName + ', ' + year;
    } catch (error) {}
  }

  //todo:DataFetch
  getInvoiceDetailBalancesForInvoiceNumber(invoiceNumber: string): void {
    let quickSearchResults: QuickSearchResults;

    this.subInvoiceDetail = this.invoiceService
      .getInvoiceDetailByInvoiceNumber(invoiceNumber, this._appGeneralStateService.currentLotNumber)
      .subscribe({
        error: (err) => (this.errorMessage = err),
        next: (results) => (quickSearchResults = results),
        complete: () => {
          this.invoiceDetailData = quickSearchResults;
          this.setInvoiceDetailData();
          this.quicksearchService.synchInvoiceToCachedData(this.invoiceDetailData);
          this.GetInvoiceListByEntityIdWithBalance(this.invoiceDetailData.entityId, invoiceNumber);
        },
      });
  }

  GetInvoiceListByEntityIdWithBalance(entityId: string, currentInvoiceNmber) {
    this.dataService.GetInvoiceListByEntityIdWithBalance(entityId).subscribe(
      (result) => {
        this.invoiceBalanceList = result;
      },
      (err: any) => {},
      () => {
        //Remove the current invoice.  THis is used to present a list of other invoices BESIDES current invoice for user to transfer payment values to
        this.invoiceBalanceList = this.invoiceBalanceList.filter((x) => x.invoiceNumber != currentInvoiceNmber);
      },
    );
  }

  OnUpdatePaymentToDeclineStatus(): void {
    let paymentDeclineStatus: IPaymentDeclineTransaction = {} as IPaymentDeclineTransaction;

    let invoicePaymentId: string = this.selectedInvoicePaymentId;

    paymentDeclineStatus.invoicePaymentId = invoicePaymentId;
    paymentDeclineStatus.comment = this.spaceDeclineRefundForm.get('comment').value;

    let resultStatus: boolean = this.UpdatePaymentToDeclineStatus(paymentDeclineStatus);
  }

  UpdatePaymentToDeclineStatus(invoiceDeclineData: IPaymentDeclineTransaction): boolean {
    let status: boolean = true;

    this.dataService.UpdatePaymentToDeclineStatus(invoiceDeclineData).subscribe(
      (result) => {},
      (err: any) => {
        this._snackBar.open('An error occurred and this payment refund was not set to declined.', '', {
          duration: 3000,
        });
        status = false;
      },
      () => {
        status = true;
        this.showRefundWorkflowForm = false;
        this._snackBar.open('This payment refund has been successfully declined.', '', { duration: 3000 });
        this.getPaymentsForInvoiceNumber(this.invoiceNumber);
      },
    );

    return status;
  }

  GetPaymentExceptionist() {
    this._dataDomainService.GetPaymentNegativePaymentExceptionList().subscribe(
      (exceptionList) => {
        this.negativePaymentExceptionList = exceptionList;
      },
      (err: any) => {
        console.error('error getting exception list');
      },
      () => {},
    );
  }

  showWaitBanner(message: string): void {
    this.workingBannerMessage = message;
    this.showWorkingBanner = true;
  }

  hideWaitBanner(): void {
    this.workingBannerMessage = 'Stand by'; //set to generic message
    this.showWorkingBanner = false;
  }

  hideWaitShowSuccessBanner(message: string): void {
    this.showWorkingBanner = false;
    this.successBannerMessage = message;
    this.showSuccessBanner = true;

    setTimeout(() => {
      this.closeSuccessBanner();
    }, 5000);
  }

  closeSuccessBanner(): void {
    this.showSuccessBanner = false;
  }
}
